module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "custom-bg"
  }, [_c('div', {
    staticClass: "custom-bg-top"
  }, [_c('img', {
    staticClass: "logo",
    attrs: {
      "src": require("../assets/logo.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "box"
  }, [(_vm.type == 1) ? _c('img', {
    staticClass: "box-img",
    attrs: {
      "src": require("../assets/image/youxiu_logo_wenzi@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('all.wangjimima')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "name"
  }, [_vm._v(_vm._s(_vm.$t('all.youxiangzhuce')))]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_youxiang@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.email),
      expression: "form.email"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruningdeyouxiangzhanghao'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.email)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "email", $event.target.value)
      }
    }
  })]), _vm._v(" "), (_vm.type != 1) ? _c('div', {
    staticClass: "box-yzm"
  }, [_c('div', {
    staticClass: "box-input1"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yanzhengma@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.loginEmailCode),
      expression: "form.loginEmailCode"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyanzhengma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.loginEmailCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "loginEmailCode", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "huoqu",
    on: {
      "click": _vm.getCode
    }
  }, [_vm._v(_vm._s(_vm.countdown ? _vm.timeText : _vm.$t('all.huoquyanzhengma')))])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-input"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_mima@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.password),
      expression: "form.password"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.password)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "password", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yincang@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yulan@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPassword = !_vm.isPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "wjma",
    on: {
      "click": _vm.handleWangjimima
    }
  }, [_vm._v(_vm._s(_vm.$t('all.wangjimima')) + "？")]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "wjma",
    on: {
      "click": _vm.handleMimadenglu
    }
  }, [_vm._v(_vm._s(_vm.$t('all.mimadenglu')))]) : _vm._e(), _vm._v(" "), (_vm.type != 1) ? _c('div', {
    staticClass: "des"
  }, [_vm._v(_vm._s(_vm.$t('all.mimashuoming')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/jbxx_yonghuming@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyonghuming'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.yonghumingtishi')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/jbxx_jiaoyimima@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "text",
      "placeholder": _vm.$t('all.shezhijiaoyimima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "autocomplete": "new-password",
      "type": "password",
      "placeholder": _vm.$t('all.shezhijiaoyimima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yincang@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yulan@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e()]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaoyimimatishi')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input3"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": _vm.form.countryImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xian"
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('all.qingxuanze')
    },
    model: {
      value: (_vm.form.countryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "countryId", $$v)
      },
      expression: "form.countryId"
    }
  }, _vm._l((_vm.allCountryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "box-input2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invitationCode),
      expression: "form.invitationCode"
    }],
    staticClass: "box-input-input1",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyaoqingma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.invitationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invitationCode", $event.target.value)
      }
    }
  })]) : _vm._e(), _vm._v(" "), (_vm.type != 2) ? _c('div', {
    staticClass: "xieyi",
    on: {
      "click": function($event) {
        _vm.isFlag = !_vm.isFlag
      }
    }
  }, [(!_vm.isFlag) ? _c('img', {
    attrs: {
      "src": require("../assets/image/xuanze_16_1@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isFlag) ? _c('img', {
    attrs: {
      "src": require("../assets/image/xuanze_16_2@2x.png"),
      "alt": ""
    }
  }) : _vm._e(), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span"
  }, [_vm._v(_vm._s(_vm.$t('all.woyiyuedubingtongyi')))]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v("《" + _vm._s(_vm.$t('all.yonghuxieyi')) + "》、")]), _vm._v(" "), _c('span', {
    staticClass: "xieyi-span1",
    on: {
      "click": function($event) {
        $event.stopPropagation();
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v("《" + _vm._s(_vm.$t('all.yinsixieyi')) + "》")])]) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toLogin
    }
  }, [_vm._v(_vm._s(_vm.$t('all.denglu')))]) : _vm._e(), _vm._v(" "), (_vm.type == 2) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toForgetPassword
    }
  }, [_vm._v(_vm._s(_vm.$t('all.chongxindenglu')))]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhuce')))]) : _vm._e(), _vm._v(" "), (_vm.type == 1) ? _c('div', {
    staticClass: "zhuce",
    on: {
      "click": function($event) {
        return _vm.handleZhuce(3)
      }
    }
  }, [_c('span', {
    staticClass: "zhuce-span"
  }, [_vm._v(_vm._s(_vm.$t('all.haimeizhanghao')) + "？")]), _vm._v(" "), _c('span', {
    staticClass: "zhuce-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.quzhuce')))])]) : _vm._e(), _vm._v(" "), (_vm.type == 3) ? _c('div', {
    staticClass: "zhuce",
    on: {
      "click": function($event) {
        return _vm.handleZhuce(1)
      }
    }
  }, [_c('span', {
    staticClass: "zhuce-span"
  }, [_vm._v(_vm._s(_vm.$t('all.yiyouzhanghao')) + "，")]), _vm._v(" "), _c('span', {
    staticClass: "zhuce-span1"
  }, [_vm._v(_vm._s(_vm.$t('all.qudenglu')))])]) : _vm._e()])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom"
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy"
  }, [_c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": function($event) {
        return _vm.handleShowModel(1)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yonghuxieyi')))]), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": function($event) {
        return _vm.handleShowModel(2)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('all.yinsixieyi')))]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-xy-div"
  }, [_c('el-popover', {
    attrs: {
      "placement": "top",
      "trigger": "click"
    }
  }, [_c('div', {
    staticClass: "custom-bg-bottom-xy-div-model"
  }, _vm._l((_vm.yyList), function(item, index) {
    return _c('div', {
      key: index,
      class: _vm.yyListIndex === index ? 'custom-bg-bottom-xy-div-model-item' : 'custom-bg-bottom-xy-div-model-item1',
      on: {
        "click": function($event) {
          return _vm.handleChooseYy(index, item.language)
        }
      }
    }, [_vm._v(_vm._s(item.name))])
  }), 0), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    attrs: {
      "slot": "reference"
    },
    slot: "reference"
  }, [_vm._v(_vm._s(_vm.$t('all.yuyanxuanze')))])])], 1), _vm._v(" "), _c('span', {
    staticClass: "custom-bg-bottom-xy-span",
    on: {
      "click": _vm.handleShowXiazai
    }
  }, [_vm._v(_vm._s(_vm.$t('all.appxiazai')))])]), _vm._v(" "), _c('div', {
    staticClass: "custom-bg-bottom-des"
  }, [_vm._v("COPYRIGHT © 2026 WWW.UNISHOW.LIVE")])]), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-overlay",
    on: {
      "click": function($event) {
        _vm.isModalVisible = false
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isModalVisible) ? _c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-content-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhijibenxinxi')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-des"
  }, [_vm._v(_vm._s(_vm.$t('all.nichengtishi')))]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list"
  }, [_c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhiyonghuming')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/jbxx_yonghuming@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.userName),
      expression: "form.userName"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyonghuming'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.userName)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "userName", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.yonghumingtishi')))])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.shezhijiaoyimima')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/jbxx_jiaoyimima@2x.png"),
      "alt": ""
    }
  }), _vm._v(" "), (!_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "text",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.payPassword),
      expression: "form.payPassword"
    }],
    staticClass: "box-input-input",
    attrs: {
      "type": "password",
      "placeholder": _vm.type === 1 ? _vm.$t('all.qingshurumima') : _vm.$t('all.shezhixinmima'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.payPassword)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "payPassword", $event.target.value)
      }
    }
  }) : _vm._e(), _vm._v(" "), (_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yincang@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e(), _vm._v(" "), (!_vm.isPayPassword) ? _c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": require("../assets/image/denglu_yulan@2x.png"),
      "alt": ""
    },
    on: {
      "click": function($event) {
        _vm.isPayPassword = !_vm.isPayPassword
      }
    }
  }) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item-des"
  }, [_vm._v(_vm._s(_vm.$t('all.jiaoyimimatishi')))])])]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list"
  }, [_c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.xuanzeningdeguojia')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input3"
  }, [_c('img', {
    staticClass: "box-input-img",
    attrs: {
      "src": _vm.form.countryImage,
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "xian"
  }), _vm._v(" "), _c('el-select', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "filterable": "",
      "placeholder": _vm.$t('all.qingxuanze')
    },
    model: {
      value: (_vm.form.countryId),
      callback: function($$v) {
        _vm.$set(_vm.form, "countryId", $$v)
      },
      expression: "form.countryId"
    }
  }, _vm._l((_vm.allCountryList), function(item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    })
  }), 1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "modal-content-list-item"
  }, [_c('div', {
    staticClass: "modal-content-list-item-title"
  }, [_vm._v(_vm._s(_vm.$t('all.yaoqingma')))]), _vm._v(" "), _c('div', {
    staticClass: "box-input2"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.invitationCode),
      expression: "form.invitationCode"
    }],
    staticClass: "box-input-input1",
    attrs: {
      "type": "text",
      "placeholder": _vm.$t('all.qingshuruyaoqingma'),
      "placeholder-style": "color:rgba(255,255,255,0.6)"
    },
    domProps: {
      "value": (_vm.form.invitationCode)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "invitationCode", $event.target.value)
      }
    }
  })])])]), _vm._v(" "), _c('div', {
    staticClass: "btn",
    on: {
      "click": _vm.toRegister
    }
  }, [_vm._v(_vm._s(_vm.$t('all.zhuce')))])]) : _vm._e(), _vm._v(" "), _c('xieyi', {
    ref: "xieyi"
  }), _vm._v(" "), _c('xiazai', {
    ref: "xiazai"
  })], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2702782d"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/views/Login.vue
// module id = 811
// module chunks = 1